import { FormattedMessage, useIntl } from 'react-intl';
import _get from 'lodash/get';
import cx from 'classnames';
import { useParallax } from 'react-scroll-parallax';
import JoinButtonAccount from '@/widgets/Landing/btc/components/JoinButton';
import ThemeButton from '@/shared/ui/ThemeButton';
import { useNavigation } from '@/processes/Router';
import { useMinerAccount } from "@/processes/MinerAccounts";
import s from './JoinSection.module.css';
import { useDiscountRequestModal } from '~/marketing';
import TutorialLink from '@/entities/TutorialLink';

type JoinSectionProps = {
  className?: string;
  titleKey?: string;
}

const tutorialLink = 'https://hiveon.com/knowledge-base/guides/how-to-mine-bitcoin-hiveon-pool-account-wallet/';

const JoinSection = (props: JoinSectionProps) => {
  const { 
    className,
    titleKey = 'footer.join.title',
  } = props;
  const { isAuth } = useMinerAccount();
  const { coin, coinTitle, poolDashboardLink, navigate } = useNavigation();
  
  const intl = useIntl();
  const { ref: refParallax1 } = useParallax({ translateY: ['100px', '-100px'] });
  const { ref: refParallax2 } = useParallax({ translateY: ['-100px', '100px'] });
  const { ref: refParallax3 } = useParallax({ translateY: ['50px', '-50px'] });
  const { openModal: openDiscountModal } = useDiscountRequestModal();

  return (
    <section className={cx(className, s.root)}>
      <span ref={refParallax1} className={cx(s.coinImg, s.coinImg1, 'top-0 -left-20 md:-top-12 md:-left-80')} aria-hidden={true}/>
      <span ref={refParallax2} className={cx(s.coinImg, s.coinImg2, 'top-0 -right-24 md:-top-36 md:-right-56')} aria-hidden={true}/>
      <span ref={refParallax3} className={cx(s.coinImg, s.coinImg3, '-bottom-12 right-20 md:-bottom-16 md:right-40')} aria-hidden={true}/>

      <div className={cx("flex items-center sm:items-start flex-col sm:flex-row justify-center w-full", className)}>
        <div className="flex-grow-1">
          <h2 className="text-4/5xl sm:text-left sm:text-8xl font-bold my-5 sm:mt-0 sm:mb-8">
            <FormattedMessage id="l.btc.fpps.t" values={{ span: (...chunks) => <span className="theme-text-highlight">{chunks}</span>, }} />
          </h2>
          <div className="mt-8 gap-4 flex-col sm:flex-row sm:gap-8 flex items-start  justify-center sm:justify-start">
            {isAuth ? (
              <ThemeButton onClick={() => {
                navigate(poolDashboardLink);
              }}><FormattedMessage id="dashboard" /></ThemeButton>
            ) : (
              <JoinButtonAccount 
                title={intl.formatMessage({ id: 'l.btn.cta.v1' }, { coin })}
              />
            )}
            <ThemeButton onClick={() => openDiscountModal()}>
              <FormattedMessage id="l.btc.cta" />
            </ThemeButton>
          </div>
        </div>
      </div>

      <div className="flex justify-center text-center my-8 sm:my-20">
        <TutorialLink
          target="_blank"
          label="tutorialLink.howTo"
          link={tutorialLink}
          data-gtm-category="site_pool"
          data-gtm-action="tutorial_click"
          data-gtm-label={JSON.stringify({
            tutorial_type: 'btc',
          })}
        />
      </div>
    </section>
  );
}

export default JoinSection;
